import { useIntl } from 'react-intl';

import type { ButtonProps, ButtonVariant } from '@/components/LegacyButton';
import { LegacyButton } from '@/components/LegacyButton';
import { Visibility } from '@/components/Visibility';
import { getVariantCTA } from '@/lib/product';
import type { CtaType } from '@/lib/types';

export interface CTAProps extends Pick<
  ButtonProps,
  'isProcessing' | 'disabled' | 'onClick'
> {
  cta: CtaType | undefined;
  loading: boolean;
  variant?: ButtonVariant;
}

export const CTA = ({
  cta,
  loading,
  variant = 'filled',
  ...props
}: CTAProps) => {
  const { formatMessage } = useIntl();

  if (!cta) {
    return null;
  }

  return (
    <Visibility data-test-id='CTAVisibility' handleDisplay={false}>
      <LegacyButton
        colorVariant={loading ? 'gray' : 'primary'}
        data-test-id='CTALegacyButton'
        disabled={loading}
        isFluid
        label={loading ? '' : getVariantCTA(formatMessage, cta)}
        variant={variant}
        {...props}
      />
    </Visibility>
  );
};
